import { autoVeloSiteCallForAMethod } from '@wix/bi-logger-auto-velo/v2';
import { createTicketDefinition as universalCreateTicketDefinition, updateTicketDefinition as universalUpdateTicketDefinition, getTicketDefinition as universalGetTicketDefinition, deleteTicketDefinition as universalDeleteTicketDefinition, reorderTicketDefinitions as universalReorderTicketDefinitions, queryTicketDefinitions as universalQueryTicketDefinitions, queryAvailableTicketDefinitions as universalQueryAvailableTicketDefinitions, countTicketDefinitions as universalCountTicketDefinitions, countAvailableTicketDefinitions as universalCountAvailableTicketDefinitions, bulkDeleteTicketDefinitionsByFilter as universalBulkDeleteTicketDefinitionsByFilter, changeCurrency as universalChangeCurrency, } from './events-v3-ticket-definition.universal';
import { PricingTypeEnumType, Type, SaleStatusEnumStatus, WebhookIdentityType, ReservationStatus, Field, SortOrder, LocationType, SubdivisionType, Status, EventStatus, EventType, RegistrationStatus, RsvpStatusOptions, TaxType, VisitorType, InputControlType, ValueType, ConferenceType, CategoryStateState, State, SiteCreatedContext, Namespace, DeleteStatus, } from './events-v3-ticket-definition.universal';
function wrapSideEffect(sideEffect) {
    return (...args) => {
        try {
            sideEffect(...args);
        }
        catch (e) {
            // add some kind of log?
        }
    };
}
function createSideEffects(sideEffects) {
    return Object.entries(sideEffects).reduce((acc, [key, value]) => {
        acc[key] = wrapSideEffect(value);
        return acc;
    }, {});
}
function createVeloSiteCallLogData(params) {
    return autoVeloSiteCallForAMethod(Object.assign({ environment: 'front-end', entity_name: 'wix.events.v3.ticket_definition', module_name: 'wix-events.v2' }, params));
}
export function sdkFactory({ appEssentials }) {
    const httpClient = appEssentials.httpClient;
    const logger = appEssentials
        .biLoggerFactory({ endpoint: 'auto-velo' })
        .logger();
    return {
        createTicketDefinition: (ticketDefinition, options) => {
            const methodLogData = {
                method_name: 'createTicketDefinition',
                service_name: 'wix.events.ticketdef.v3.TicketDefinitionManagement',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-events.v2,entity=wix.events.v3.ticket_definition,environment=velo-frontend,method-fqn=wix.events.ticketdef.v3.TicketDefinitionManagement.createTicketDefinition',
            };
            return universalCreateTicketDefinition(ticketDefinition, options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        updateTicketDefinition: (_id, ticketDefinition, options) => {
            const methodLogData = {
                method_name: 'updateTicketDefinition',
                service_name: 'wix.events.ticketdef.v3.TicketDefinitionManagement',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-events.v2,entity=wix.events.v3.ticket_definition,environment=velo-frontend,method-fqn=wix.events.ticketdef.v3.TicketDefinitionManagement.updateTicketDefinition',
            };
            return universalUpdateTicketDefinition(_id, ticketDefinition, options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        getTicketDefinition: (ticketDefinitionId, options) => {
            const methodLogData = {
                method_name: 'getTicketDefinition',
                service_name: 'wix.events.ticketdef.v3.TicketDefinitionManagement',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-events.v2,entity=wix.events.v3.ticket_definition,environment=velo-frontend,method-fqn=wix.events.ticketdef.v3.TicketDefinitionManagement.getTicketDefinition',
            };
            return universalGetTicketDefinition(ticketDefinitionId, options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        deleteTicketDefinition: (ticketDefinitionId) => {
            const methodLogData = {
                method_name: 'deleteTicketDefinition',
                service_name: 'wix.events.ticketdef.v3.TicketDefinitionManagement',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-events.v2,entity=wix.events.v3.ticket_definition,environment=velo-frontend,method-fqn=wix.events.ticketdef.v3.TicketDefinitionManagement.deleteTicketDefinition',
            };
            return universalDeleteTicketDefinition(ticketDefinitionId, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        reorderTicketDefinitions: (eventId, options) => {
            const methodLogData = {
                method_name: 'reorderTicketDefinitions',
                service_name: 'wix.events.ticketdef.v3.TicketDefinitionManagement',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-events.v2,entity=wix.events.v3.ticket_definition,environment=velo-frontend,method-fqn=wix.events.ticketdef.v3.TicketDefinitionManagement.reorderTicketDefinitions',
            };
            return universalReorderTicketDefinitions(eventId, options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        queryTicketDefinitions: (options) => {
            const methodLogData = {
                method_name: 'queryTicketDefinitions',
                service_name: 'wix.events.ticketdef.v3.TicketDefinitionManagement',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-events.v2,entity=wix.events.v3.ticket_definition,environment=velo-frontend,method-fqn=wix.events.ticketdef.v3.TicketDefinitionManagement.queryTicketDefinitions',
            };
            return universalQueryTicketDefinitions(options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        queryAvailableTicketDefinitions: (query, options) => {
            const methodLogData = {
                method_name: 'queryAvailableTicketDefinitions',
                service_name: 'wix.events.ticketdef.v3.TicketDefinitionManagement',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-events.v2,entity=wix.events.v3.ticket_definition,environment=velo-frontend,method-fqn=wix.events.ticketdef.v3.TicketDefinitionManagement.queryAvailableTicketDefinitions',
            };
            return universalQueryAvailableTicketDefinitions(query, options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        countTicketDefinitions: (options) => {
            const methodLogData = {
                method_name: 'countTicketDefinitions',
                service_name: 'wix.events.ticketdef.v3.TicketDefinitionManagement',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-events.v2,entity=wix.events.v3.ticket_definition,environment=velo-frontend,method-fqn=wix.events.ticketdef.v3.TicketDefinitionManagement.countTicketDefinitions',
            };
            return universalCountTicketDefinitions(options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        countAvailableTicketDefinitions: (options) => {
            const methodLogData = {
                method_name: 'countAvailableTicketDefinitions',
                service_name: 'wix.events.ticketdef.v3.TicketDefinitionManagement',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-events.v2,entity=wix.events.v3.ticket_definition,environment=velo-frontend,method-fqn=wix.events.ticketdef.v3.TicketDefinitionManagement.countAvailableTicketDefinitions',
            };
            return universalCountAvailableTicketDefinitions(options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        bulkDeleteTicketDefinitionsByFilter: (filter) => {
            const methodLogData = {
                method_name: 'bulkDeleteTicketDefinitionsByFilter',
                service_name: 'wix.events.ticketdef.v3.TicketDefinitionManagement',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-events.v2,entity=wix.events.v3.ticket_definition,environment=velo-frontend,method-fqn=wix.events.ticketdef.v3.TicketDefinitionManagement.bulkDeleteTicketDefinitionsByFilter',
            };
            return universalBulkDeleteTicketDefinitionsByFilter(filter, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        changeCurrency: (eventId, options) => {
            const methodLogData = {
                method_name: 'changeCurrency',
                service_name: 'wix.events.ticketdef.v3.TicketDefinitionManagement',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-events.v2,entity=wix.events.v3.ticket_definition,environment=velo-frontend,method-fqn=wix.events.ticketdef.v3.TicketDefinitionManagement.changeCurrency',
            };
            return universalChangeCurrency(eventId, options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        PricingTypeEnumType,
        Type,
        SaleStatusEnumStatus,
        WebhookIdentityType,
        ReservationStatus,
        Field,
        SortOrder,
        LocationType,
        SubdivisionType,
        Status,
        EventStatus,
        EventType,
        RegistrationStatus,
        RsvpStatusOptions,
        TaxType,
        VisitorType,
        InputControlType,
        ValueType,
        ConferenceType,
        CategoryStateState,
        State,
        SiteCreatedContext,
        Namespace,
        DeleteStatus,
    };
}
//# sourceMappingURL=events-v3-ticket-definition.frontend.js.map